const OpeningPhraseSection = () => {
  return (
    <section className="py-20 sm:py-28 px-6 bg-[#ecd9c1]">
      <div className="max-w-2xl mx-auto text-center space-y-8">
        <p 
          className="font-serif text-lg sm:text-xl md:text-2xl text-[#3F2A24]/80 leading-[2] whitespace-pre-line"
          style={{ textWrap: 'balance' }}
        >
          {"Il existe des lieux\noù quelque chose en nous\ncesse enfin de résister."}
        </p>
        
        <div className="w-12 h-[1px] bg-[#C5A059]/40 mx-auto" />
        
        <p 
          className="font-serif text-lg sm:text-xl md:text-2xl text-[#3F2A24] italic"
        >
          Valouse est l'un de ces lieux.
        </p>
      </div>
    </section>
  );
};

export default OpeningPhraseSection;
